var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-4"},_vm._l((_vm.user),function(detail,name){return _c('dl',{key:name,staticClass:"row",attrs:{"data-testid":name}},[_c('dt',{staticClass:"col-lg-4"},[_vm._v(" "+_vm._s(_vm.$t(`common.user.${name}`))+" ")]),_c('dd',{staticClass:"col-lg-8 mb-4"},[_vm._v(" "+_vm._s(detail || _vm.blankValueIndicator)+" ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }